import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";

import { showLoader, hideLoader, showAlert, isEmpty, showContaimerLoader, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "vesseltype";
const modulePath = "/vesseltype";
const moduleName = "Vessel Type";
const moduleID = 3;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        vesselName: "",
      },
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;
          const clientupdatedata = {
            vesselName: result.vesselName,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      vesselName: postData.vesselName.toLowerCase(),
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { vesselName } = props.fields;

  return {
    fields: ["vesselName"],
    validations: {
      vesselName: [[isEmpty, vesselName]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgvesselName = "";
    if ($validation.vesselName.error.reason !== undefined) {
      errMsgvesselName = $validation.vesselName.show && <span className="error">{$validation.vesselName.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Vessel Type<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Vessel Type"
                name="vesselName"
                value={fields.vesselName}
                {...$field("vesselName", (e) => onChange("vesselName", e.target.value))}
              />
              {errMsgvesselName}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
